<template>
  <b-modal
      :id="'show-url2'+slug"
      centered
      no-close-on-backdrop
      size="lg"
  >
    <template #modal-header>
      <h3>{{ $t('modals.showItemUrl.title') }}</h3>
    </template>
    <div class="show-url-icon text-center px-2">
      <b-icon icon="check-circle" variant="success" class="mt-5 mb-4"></b-icon>
      <p class="mt-2 mb-2" v-html="$t('modals.showItemUrl.message')"></p>
      <div class="mb-2 px-2">
        <div class="url-copy-container d-flex align-items-center justify-content-center mb-3">
          <a class="show-url mr-2" :href="publishingUrl" target="_blank">
            <u>{{ publishingUrl }}</u>
          </a>
          <b-button
            size="sm"
            class="text-dark"
            variant="light"
            @click="copyCleanUrl"
            v-b-tooltip.hover
            :title="$t('buttons.copyLink')"
          >
            <b-icon :icon="cleanUrlCopied ? 'check' : 'clipboard'"></b-icon>
          </b-button>
        </div>

        <!-- UTM Sharing Section -->  <!-- UTM Sharing Section -->
        <UtmShareSection
          :publishing-url="publishingUrl"
          :page-type="pageType"
          :slug="slug"
      />
        <!-- QR Code Section -->
        <b-button v-b-toggle.collapse-qr class="m-1 light-grey-button" size="sm">
          {{ $t('modals.qrCode.button') }}
        </b-button>
        <b-collapse id="collapse-qr">
          <div class="pt-3">
            <p><img :src="`https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${publishingUrl}`" alt="QR Code"></p>
            <p>
              <a :href="`https://api.qrserver.com/v1/create-qr-code/?format=svg&data=${publishingUrl}&download=1`">{{ $t('modals.qrCode.svg') }}</a>
              <br>
              <a :href="`https://api.qrserver.com/v1/create-qr-code/?size=1000x1000&format=jpg&data=${publishingUrl}&download=1`">{{ $t('modals.qrCode.jpg') }}</a>
            </p>
          </div>
        </b-collapse>
      </div>

      <!-- Personalised URLs Section -->
      <div class="mb-4 px-2" v-if="personalisedURLs.length > 0">
        <b-button v-b-toggle.collapse-personalised class="mt-2 mb-2 light-grey-button" size="sm">
          <span class="when-open">{{ $t('modals.personalisedURLs.closeButton') }}</span>
          <span class="when-closed">{{ $t('modals.personalisedURLs.openButton') }}</span>
        </b-button>
        <b-collapse id="collapse-personalised">
          <div v-for="item in personalisedURLs" :key="item" class="personalised-url-item">
            <a :href="`${publishingUrl}?pz=${item}`" target="_blank">
              {{ `${publishingUrl}?pz=${item}` }}
            </a>
          </div>
        </b-collapse>
      </div>
    </div>
    <template #modal-footer>
      <b-button
        class="p-3"
        block
        @click="$emit('close-modal')"
      >
        {{ $t('buttons.ok') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import GetPersonalizedVariableSetsItems from '@/graphQlQueries/queries/getPersonalizedVariableSetsItems';
import UtmShareSection from '@/components/modals/UtmShareSection.vue';

export default {
  name: 'ModalShowUrl',
  components: {
    UtmShareSection,
  },
  props: ['slug', 'slugPath', 'pageType', 'groupDomain', 'itemPath'],
  data: () => ({
    publishingUrl: null,
    personalisedURLs: [],
    loading: 0,
    cleanUrlCopied: false,
    copyTimeout: null,
  }),
  created() {
    this.publishingUrl = `${this.groupDomain}${this.slugPath}`;
    if (this.pageType === 'project') {
      this.publishingUrl = `${this.publishingUrl}/`;
    }
  },
  mounted() {
    this.$bvModal.show(`show-url2${this.slug}`);
  },
  methods: {
    async copyCleanUrl() {
      try {
        await navigator.clipboard.writeText(this.publishingUrl);
        this.cleanUrlCopied = true;

        if (this.copyTimeout) {
          clearTimeout(this.copyTimeout);
        }

        this.copyTimeout = setTimeout(() => {
          this.cleanUrlCopied = false;
        }, 2000);

        this.$bvToast.toast(this.$t('modals.showPublishSuccess.linkCopied'), {
          variant: 'success',
          solid: true,
          autoHideDelay: 2000,
          noCloseButton: true,
        });
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    },
  },
  beforeDestroy() {
    if (this.copyTimeout) {
      clearTimeout(this.copyTimeout);
    }
  },
  apollo: {
    loading: {
      query: GetPersonalizedVariableSetsItems,
      variables() {
        return {
          itemPath: this.itemPath,
          addValues: true,
        };
      },
      update(data) {
        this.personalisedURLs = [];
        if (data.getPersonalizedVariableSetsByPath.length) {
          data.getPersonalizedVariableSetsByPath.forEach((set) => {
            if (set.values && set.values.length) {
              set.values.forEach((value) => {
                if (!this.personalisedURLs.includes(value.client_key)) {
                  this.personalisedURLs.push(value.client_key);
                }
              });
            }
          });
        }
      },
      skip() {
        return !this.itemPath;
      },
      fetchPolicy: 'network-only',
    },
  },
};
</script>

<style scoped lang="scss">
.show-url-icon svg {
  font-size: 60px;
}
.show-url {
  font-size: 1rem;
  word-break: break-all;
}
.url-copy-container {
  padding: 0.75rem;
  border-radius: 8px;
}
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
.personalised-url-item {
  padding: 0.25rem 0;
  font-size: 0.9rem;

  a {
    word-break: break-all;
  }
}
</style>
